import { render, staticRenderFns } from "./UploadDataCollections.vue?vue&type=template&id=5404b164&"
import script from "./UploadDataCollections.vue?vue&type=script&lang=js&"
export * from "./UploadDataCollections.vue?vue&type=script&lang=js&"
import style0 from "./UploadDataCollections.vue?vue&type=style&index=0&id=5404b164&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports